import ReportDetails from './ReportDetails.component';

export default ReportDetails;